module.exports = __webpack_public_path__ + "static/media/Image 565.43670acf.png";